<template>
  <div v-if="loading">
    
  </div>
  <div v-else>

    <v-btn
      outlined
      class="text-none mb-4 pl-3 pr-3"
      color="gray12Color"
      style="background: var(--v-whiteColor-base);"
      @click="$router.push(`/sites/${site.id}/campaign/${campaign.id}/keyword-strategy`)"
    >
      <i class="material-icons-outlined mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">arrow_back</i> <span style="color: var(--v-blackColor-base);">Back to Keyword Strategy</span>
    </v-btn>
    
    <div v-if="report">
        
      <div>
        <div class="mb-1" style="color: var(--v-gray50Color-base); font-size: 1rem;">{{ site.name }}</div>
        
        <div class="d-flex align-center justify-space-between gap10 mb-6">
          
          <div class="card-big-title" style="color: var(--v-blackColor-base); font-weight: 700; font-size: 1.5rem;">
            Custom silo results
            <span class="material-icons video-tutorial-icon video-tutorial-icon-size"
              @click="() => {
                $store.commit('setCurrentVideoTutorialToDisplay', {
                  title: 'How Pros Build Custom SEO Silos (Full Control)',
                  videoLink: 'https://www.youtube.com/embed/d-as3x6gn7U',
                  description: 'In this video, Heather Cumins, a Customer Success Manager at PageOptimizer Pro, shows you how to use POP’s Custom Silo to turn up to 10 target keywords or 20 competitor URLs into a fully ready, implementable content strategy.',
                  time: '5m 27s'
                });
              }">
              videocam
            </span>
          </div>

          <div class="d-flex align-center gap10">
            <b-dropdown aria-role="list" position="is-bottom-left">
              <template #trigger>
                <v-btn
                  outlined
                  class="text-none"
                  color="gray12Color"
                  style="background: var(--v-whiteColor-base);"
                >
                  <i class="material-icons mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">school</i> <span style="color: var(--v-blackColor-base);">Working with results</span>
                </v-btn>
              </template>
    
              <b-dropdown-item custom style="width: 1000px;">
                <working-with-results-part />
              </b-dropdown-item>
            </b-dropdown>
  
            <v-btn
              outlined
              class="text-none"
              color="gray12Color"
              style="background: var(--v-whiteColor-base);"
              href="https://help.pageoptimizer.pro/article/difference-between-top-level-and-supporting-content-keywords"
              target="_blank"
            >
              <i class="material-icons mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">school</i> <span style="color: var(--v-blackColor-base);">How to use this dashboard?</span>
            </v-btn>
          </div>
          
        </div>
        
      </div>

      <div
        v-if="currentAsyncTask?.is_pending_or_in_progress"
        class="d-flex flex-column align-center pt-8 pb-8"
      >
        <div class="d-flex flex-column align-center" style="max-width: 500px; text-align: center;">
          <img src="/static/keyword-insight-processing-image.svg" width="315" height="222" class="mb-4" />
          <div class="mb-6" style="font-size: 1.2rem; font-weight: bold; line-height: 1.6; max-width: 400px;">Hang tight! Your silo’s on the way - this can take up to 7 minutes…</div>
    
          <v-progress-linear
            class="mb-4" 
            style="max-width: 300px;"
            rounded height="5"
            color="profileAnchorColor"
            :value="currentAsyncTask.task_status.value || 0">
          </v-progress-linear>

          <div style="font-size: 1rem; color: var(--v-gray50Color-base);">{{ currentAsyncTask.task_status.status === 'PENDING' ? 'Starting...' : currentAsyncTask.task_status.msg }}</div>
        </div>
      </div>

      <keyword-research-result
        v-else-if="!!topic"
        title="Custom Silo"
        reportType="SiloResearchTopic"
        siloResearchType="custom-silo"
        :report="topic"
        :parentReport="report"
        :topicsWithMetrics="report.topics.filter(t => !!t.hasMetrics)"
        :researchHistory="[]"
        :hasUnlimitedAccess="hasUnlimitedAccess"

        @refreshReport="() => loadReport()"
        @onAIResultReady="() => loadReport()"
        @onKeywordLabelUpdateSuccess="onKeywordLabelUpdateSuccess"
      />

      <div v-else>
        Invalid request
      </div>
      

    </div>

    <div v-else>
      <div class="card-big-title mb-8 d-flex gap10">
        No report found
      </div>
    </div>

  </div>
</template>

<script>
import KeywordResearchResult from '@/components/Campaigns/KeywordResearchResult.vue';
import WorkingWithResultsPart from './WorkingWithResultsPart.vue';


export default {
  props: ['site', 'campaign', 'hasUnlimitedAccess', 'isWhiteGloveUser', 'isMissionControlSession', 'reloadUser'],
  components: {
    KeywordResearchResult,
    WorkingWithResultsPart
  },
  data () {
    return {
      loading: true,
      report: null,
    }
  },
  computed: {
    asyncTasks() {
      return this.$store.state.asyncTasks
    },
    currentAsyncTask() {
      return this.asyncTasks.filter(task => task.type.startsWith('SiloResearch.custom_silo_get_keywords_task') && task.record_id === this.report?.id)[0]
    },
    currentAsyncTasksForTopicMetrics() {
      return this.asyncTasks.filter(task => task.type.startsWith('SiloResearch.custom_silo_get_metrics_task') && (this.report?.topics || []).map(topic => topic.id).includes(task.record_id))
    },
    currentAsyncTasksForTopicMetricsMap() {
      return Object.fromEntries(this.currentAsyncTasksForTopicMetrics.map(task => [task.record_id, task]))
    },
    topic() {
      return (this.report?.topics || []).filter(topic => topic.id === Number(this.$route.params.topicId))?.[0]
    }
  },
  watch: {
    // Rocky's refresh signal (PopAssistantButton.handleRefresh). A research
    // POP Pilot started through the API is not in the store's task list, so
    // currentAsyncTask never flips here; reload the report when asked.
    '$store.state.triggerRockyRefresh': function () {
      this.loadReport()
    },
    currentAsyncTask: function (newVal, oldVal) {
      if (newVal?.is_completed && oldVal && newVal?.is_completed !== oldVal?.is_completed) {
        this.reloadUser()
        this.loadReport()
      }
    },
    currentAsyncTasksForTopicMetrics: function (newVal, oldVal) {
      let reload = false

      const oldValMap = Object.fromEntries(oldVal.map(task => [task.id, task]))

      for (let index = 0; index < newVal.length; index++) {
        const newValTask = newVal[index];
        const oldValTask = oldValMap?.[newVal[index].id];
        if (newValTask.is_completed && oldValTask && newValTask?.is_completed !== oldValTask?.is_completed) {
          reload = true
          break
        }
      }

      if (reload) {
        this.reloadUser()
        this.loadReport()
      }
    }
  },
  methods: {
    onKeywordLabelUpdateSuccess(keywords, label, resetExistingTopLevelKeywords) {
      this.report = {
        ...this.report,
        topics: this.report.topics.map(topic => {
          if (topic.id === this.topic.id) {
            return {
              ...topic,
              result: topic.result.map((row) => {
                if (label === 'T' && row.isTopLevelKeyword && resetExistingTopLevelKeywords) {
                  return {
                    ...row,
                    isTopLevelKeyword: false,
                    isSecondaryKeyword: false
                  }
                }
                if (keywords.includes(row.keyword)) {
                  return {
                    ...row,
                    isTopLevelKeyword: label === 'T' || label === 'ST',
                    isSecondaryKeyword: label === 'ST',
                    isSupportingKeyword: label === 'S',
                  }
                }
                return row
              })
            }
          }
          return topic
        })
      }
    },
    loadReport () {
      return this.$store.dispatch('siloResearchSingle', {
        id: this.$route.params.id,
        includeTopics: 1,
        includeKeywords: 1,
      })
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          this.report = response.data.research
        }
      })
    },
  },
  mounted () {
    this.loadReport()
    .finally(() => {
      this.loading = false
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./../../styles.scss";
</style>